import { Home, LogOut, Package, SearchCheck, UserCircle, Zap } from "lucide-react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

import { ThemeToggle } from "@/components/ThemeToggle";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";
import { useT } from "@/lib/i18n";
import { cn } from "@/lib/utils";

/** Uy egasi uchun yengil maket (telefonda qulay; Telegram Mini App ham shuni ishlatadi). */
export function CustomerLayout() {
  const { t, lang, setLang } = useT();
  const { user, logout } = useAuth();
  const loc = useLocation();
  return (
    <div className="min-h-screen">
      <header className="glass sticky top-0 z-20 border-b border-border pt-[env(safe-area-inset-top)]">
        <div className="mx-auto flex h-14 max-w-3xl items-center gap-3 px-3">
          <span className="flex items-center gap-2 font-extrabold">
            <span className="hero-gradient flex size-9 items-center justify-center rounded-xl text-white">
              <Zap className="size-5 fill-current" />
            </span>{" "}
            <span className="hidden whitespace-nowrap lg:inline">Elektr Pasport</span>
          </span>
          <nav aria-label="main" className="flex gap-1">
            {[
              { to: "/my", key: "my.nav_homes", icon: Home, end: true },
              { to: "/my/catalog", key: "nav.catalog", icon: Package, end: false },
              { to: "/my/claim", key: "my.nav_claim", icon: SearchCheck, end: false },
              { to: "/my/profile", key: "profile.title", icon: UserCircle, end: false },
            ].map(({ to, key, icon: Icon, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  cn(
                    "flex min-h-11 items-center gap-2 rounded-xl px-3 text-sm font-semibold transition-all",
                    isActive ? "hero-gradient shadow-pop text-white" : "hover:bg-muted",
                  )
                }
              >
                <Icon className="size-4" />{" "}
                <span className="hidden whitespace-nowrap sm:inline">{t(key)}</span>
                <span className="sr-only sm:hidden">{t(key)}</span>
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-2">
            <ThemeToggle />
            <div
              className="flex overflow-hidden rounded-lg border border-border"
              role="group"
              aria-label="language"
            >
              {(["uz", "ru"] as const).map((l) => (
                <button
                  key={l}
                  aria-pressed={lang === l}
                  onClick={() => setLang(l)}
                  className={cn(
                    "min-h-9 px-3 text-xs font-bold uppercase",
                    lang === l ? "bg-primary text-primary-foreground" : "hover:bg-muted",
                  )}
                >
                  {l}
                </button>
              ))}
            </div>
            <span className="hidden text-xs sm:block">{user?.full_name || user?.phone}</span>
            <Button
              variant="ghost"
              size="icon"
              aria-label={t("auth.logout")}
              onClick={() => void logout()}
            >
              <LogOut className="size-5" />
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-3xl p-3 pb-[calc(var(--badge-safe)+env(safe-area-inset-bottom))] md:py-6">
        <div key={loc.pathname} className="anim-fade-up">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
